import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=622e4fd2&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=622e4fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e4fd2",
  null
  
)

export default component.exports